import styled from 'styled-components';

type Props = {
  $show: boolean;
};

export const Box = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  padding: 32px 24px;

  @media (min-width: 768px) {
    gap: 32px;
    padding: 48px 48px;
  }
`;

export const BtnWrapper = styled.div`
  display: flex;
  gap: 4px;
  padding: 4px;
  border-radius: ${props => props.theme.radii.pill};
  background: ${props => props.theme.brand.canvas};

  @media (min-width: 768px) {
    gap: 6px;
    padding: 6px;
  }
`;

export const NavBtn = styled.button<Props>`
  padding: 10px 24px;
  border: none;
  border-radius: ${props => props.theme.radii.pill};
  font-family: ${props => props.theme.fonts.body};
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: ${props => props.theme.transition.main};
  color: ${props =>
    props.$show ? props.theme.brand.chalk : props.theme.brand.muted};
  background: ${props =>
    props.$show ? props.theme.colors.secondary : 'transparent'};

  &:hover,
  &:focus-visible {
    color: ${props =>
      props.$show ? props.theme.brand.chalk : props.theme.colors.hoverColor};
  }

  @media (min-width: 768px) {
    padding: 12px 32px;
    font-size: 16px;
  }
`;
